import { createStore } from 'vuex'
import * as fb from '../firebase'
import router from '../router'
import { query, orderBy, onSnapshot } from 'firebase/firestore'
import { signInWithEmailAndPassword } from 'firebase/auth'

const merchModule = {
  namespaced: true,
  state: {
    merch: [],
  },
  mutations: {
    SET_MERCH(state, val) {
      state.merch = val
    },
  },
  actions: {
    fetchMerch({ commit }) {
      const merchQuery = query(
        fb.merchCollection,
        orderBy('dateCreated', 'desc')
      )
      onSnapshot(merchQuery, (snapshot) => {
        let merchArray = []
        snapshot.forEach((doc) => {
          let merchItem = doc.data()
          merchItem.id = doc.id
          merchArray.push(merchItem)
        })
        commit('SET_MERCH', merchArray)
      })
    },
  },
  getters: {
    merch: (state) => state.merch,
  },
}

const newsModule = {
  namespaced: true,
  state: {
    news: [],
  },
  mutations: {
    SET_NEWS(state, val) {
      state.news = val
    },
  },
  actions: {
    fetchNews({ commit }) {
      const newsQuery = query(fb.newsCollection, orderBy('dateCreated', 'desc'))
      onSnapshot(newsQuery, (snapshot) => {
        let newsArray = []
        snapshot.forEach((doc) => {
          newsArray.push({
            id: doc.id,
            ...doc.data(),
          })
        })
        commit('SET_NEWS', newsArray)
      })
    },
  },
  getters: {
    news: (state) => state.news,
  },
}

const pressModule = {
  namespaced: true,
  state: {
    pressLinks: [],
    quotes: [],
  },
  mutations: {
    SET_PRESS(state, val) {
      state.pressLinks = val
    },
    SET_QUOTES(state, val) {
      state.quotes = val
    },
  },
  actions: {
    fetchPress({ commit }) {
      const pressQuery = query(fb.pressCollection, orderBy('date', 'desc'))
      onSnapshot(pressQuery, (snapshot) => {
        let pressArray = []
        snapshot.forEach((doc) => {
          let pressItem = doc.data()
          pressItem.id = doc.id
          if (pressItem.date && pressItem.date.seconds) {
            pressItem.date = new Date(pressItem.date.seconds * 1000)
          } else if (pressItem.date) {
            pressItem.date = new Date(pressItem.date)
          }
          pressArray.push(pressItem)
        })
        commit('SET_PRESS', pressArray)
      })
    },
    fetchQuotes({ commit }) {
      onSnapshot(fb.quotesCollection, (snapshot) => {
        let quoteArray = []
        snapshot.forEach((doc) => {
          let quoteItem = doc.data()
          quoteItem.id = doc.id
          quoteArray.push(quoteItem)
        })
        commit('SET_QUOTES', quoteArray)
      })
    },
  },
  getters: {
    pressLinks: (state) => state.pressLinks,
    quotes: (state) => state.quotes,
  },
}

const videosModule = {
  namespaced: true,
  state: {
    videos: [],
  },
  mutations: {
    SET_VIDEOS(state, val) {
      state.videos = val
    },
  },
  actions: {
    fetchVideos({ commit }) {
      const videosQuery = query(
        fb.videosCollection,
        orderBy('dateCreated', 'desc')
      )
      onSnapshot(videosQuery, (snapshot) => {
        let videoArray = []
        snapshot.forEach((doc) => {
          videoArray.push({
            id: doc.id,
            ...doc.data(),
          })
        })
        commit('SET_VIDEOS', videoArray)
      })
    },
  },
  getters: {
    videos: (state) => state.videos,
  },
}

const store = createStore({
  modules: {
    merch: merchModule,
    news: newsModule,
    press: pressModule,
    videos: videosModule,
  },
  state: {
    merch: [],
    news: [],
    pressLinks: [],
    quotes: [],
    videos: [],
    loginFailed: false,
    userLoggedIn: false,
    username: '',
  },
  mutations: {
    LOGIN_FAILED(state) {
      state.loginFailed = true
    },
    LOGIN_USER(state) {
      state.userLoggedIn = true
      state.username = 'SqwervAdmin'
      state.loginFailed = false
    },
    LOGOUT_USER(state) {
      state.userLoggedIn = false
      state.username = ''
    },
    SET_NEWS(state, val) {
      state.news = val
    },
    SET_VIDEOS(state, val) {
      state.videos = val
    },
  },
  actions: {
    async login({ commit }, form) {
      try {
        await signInWithEmailAndPassword(fb.auth, form.email, form.password)
        commit('LOGIN_USER')
        router.push('/')
      } catch (error) {
        console.error('Login failed:', error)
        commit('LOGIN_FAILED')
      }
    },
    async logout({ commit }) {
      await fb.auth.signOut()
      commit('LOGOUT_USER')
      router.push('/')
    },
  },
  getters: {
    loginFailed: (state) => state.loginFailed,
    loggedIn: (state) => state.userLoggedIn,
    news: (state) => state.news,
    pressLinks: (state) => state.pressLinks,
    quotes: (state) => state.quotes,
    videos: (state) => state.videos,
  },
})

store.dispatch('merch/fetchMerch')
store.dispatch('news/fetchNews')
store.dispatch('press/fetchPress')
store.dispatch('press/fetchQuotes')
store.dispatch('videos/fetchVideos')

export default store
